import Flex from '@decisiv/ui-components/lib/components/Flex';
import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import spacing from '@decisiv/design-tokens/lib/spacing';

export const FormContainer = styled(Flex).attrs({ flex: 1 })`
  flex-direction: column;
  gap: ${rem(spacing.base * 1)};

  & > div {
    margin-left: 0;
    margin-right: 0;
  }
`;
